import React from 'react';

import { IMenuByTypesChild } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';
import { CardChildItemHoc } from '@r1-frontend/entities/Layout/Header/mobile/components/CardChildItemHoc';
import Promo from '@r1-frontend/entities/Layout/Header/mobile/components/Promo';

import * as ST from './styled';

interface IProps {
    item: IMenuByTypesChild,
    onClick: (item: string, menuType?: string) => void,
    clickHandler?: () => void,
    isPromoted: boolean,
}

const Card = ({ item, onClick, clickHandler }: IProps): JSX.Element => {
    return (
        <ST.CardWrapper>
            {item?.title &&
                <ST.CategoryLink>
                    {item.title}
                </ST.CategoryLink>
            }
            {item?.children?.map((child, index) => (
                child.type
                    ? <Promo
                        item={child}
                        key={index}
                        isAvailable={!!child.available}
                        isPromoted={!!child.promoted}
                        clickHandler={clickHandler}
                        onClickHandlerGA={onClick}
                    />
                    : <CardChildItemHoc
                        childItem={child}
                        key={index}
                        clickHandler={clickHandler}
                        onClickHandlerGA={onClick}
                        isAvailable={!!child.available}
                    />

            ))}
        </ST.CardWrapper>
    );
};

export default Card;
